import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import BootstrapVue from "bootstrap-vue";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import VueRouter from "vue-router";
import iView from "iview";
import "iview/dist/styles/iview.css";
import VueI18n from "vue-i18n";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import Viewer from "v-viewer";
import "viewerjs/dist/viewer.css";
import AMap from "vue-amap";

import VueMaterial from "vue-material";
import "vue-material/dist/vue-material.min.css";
import "vue-material/dist/theme/default.css";
Vue.use(AMap);
Vue.use(VueMaterial);
// 初始化vue-amap
AMap.initAMapApiLoader({
  // 高德key
  key: "656b43088365c04030331da25c2b73bd",
  // 插件集合 （插件按需引入）
  plugin: [
    "AMap.Scale",
    "AMap.OverView",
    "AMap.ToolBar",
    "AMap.MapType",
    "AMap.PlaceSearch",
    "AMap.Autocomplete",
    "AMap.Geolocation",
  ],
  uiVersion: "1.0.11", // 版本号
});

import axios from "axios";

Vue.use(Viewer, {
  defaultOptions: {
    zIndex: 9999,
  },
});
Vue.use(ElementUI);
Vue.use(iView);

Vue.use(VueRouter);
Vue.use(BootstrapVue);
Vue.config.productionTip = false;

Vue.directive("title", {
  inserted: function(el, binding) {
    document.title = el.dataset.title;
  },
});

Vue.use(VueI18n); // 通过插件的形式挂载
const i18n = new VueI18n({
  //this.$i18n.locale // 通过切换locale的值来实现语言切换
  locale: "zh",
  messages: {
    zh: require("@/assets/languages/zh.json"),
    en: require("@/assets/languages/en.json"),
  },
});

router.afterEach((to, from, next) => {
  window.scrollTo(0, 0);
});

Vue.prototype.$axios = axios;
export const postJsonRequest = (url, params) => {
  //@ReqestBody
  return axios({
    method: "post",
    url: url,
    data: params,
    dataType: "json",
    headers: {
      "Content-Type": "application/json",
    },
  });
};

// formData
export const postRequest = (url, params) => {
  //@ReqestParam
  return axios({
    method: "post",
    url: url,
    data: params,
    dataType: "json",
    transformRequest: [
      function(data) {
        let ret = "";
        for (let it in data) {
          ret +=
            encodeURIComponent(it) + "=" + encodeURIComponent(data[it]) + "&";
        }
        return ret;
      },
    ],
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
  });
};

export const getRequest = (url, data) => {
  return axios({
    method: "get",
    params: data,
    url: url,
  });
};

new Vue({
  router,
  i18n,
  el: "#app",
  render: (h) => h(App),
}).$mount("#app");
